import Login from '@/components/views/auth/Login'
import UsStates from '@/components/views/guest/UsStates.vue'
import Faq from '@/components/views/guest/Faq.vue'
import AnsiAccreditation from '@/components/views/guest/AnsiAccreditation.vue'
import Introduction from '@/components/views/guest/Introduction.vue'
import TermsOfUse from '@/components/views/guest/TermsOfUse.vue'
import PrivacyPolicy from '@/components/views/guest/PrivacyPolicy.vue'
import CertificateProgram from '@/components/views/guest/CertificateProgram.vue'

const app = process.env.APP_NAME

export default [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {auth: false, title: `${app}: Login`, pageTitle: 'Login', layout: 'standard'}
  }, {
    path: '/us-states-accepting-safe-food-handler',
    name: 'UsStates',
    component: UsStates,
    meta: {title: `${app}: US States accepting SFH`, auth: undefined, layout: 'standard'}
  }, {
    path: '/frequently-asked-questions',
    name: 'Faq',
    component: Faq,
    meta: {title: `${app}: Frequently asked questions`, auth: undefined, layout: 'standard'}
  }, {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction,
    meta: {title: `${app}: Introduction`, auth: undefined, layout: 'standard'}
  }, {
    path: '/ansi-accreditation',
    name: 'AnsiAccreditation',
    component: AnsiAccreditation,
    meta: {title: `${app}: Ansi accreditation`, pageTitle: 'Ansi accreditation', auth: undefined, layout: 'plain'}
  }, {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse,
    meta: {title: `${app}: Terms of use`, auth: undefined, pageTitle: 'User License & Terms of Use', layout: 'standard'}
  }, {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {title: `${app}: Privacy policy`, pageTitle: 'Privacy Policy', auth: undefined, layout: 'standard'}
  }, {
    path: '/certificate-program',
    name: 'CertificateProgram',
    component: CertificateProgram,
    meta: {title: `${app}: Certificate Program`, pageTitle: 'Certificate Program', auth: undefined, layout: 'standard'}
  }
]



// WEBPACK FOOTER //
// ./src/router/guest.js